/**
 * Alert component to display different types of alert messages.
 *
 * @param {Object} props - The properties object.
 * @param {string} [props.type='warning'] - The type of alert ('warning' or 'danger').
 * @param {React.ReactNode} props.children - The content to be displayed inside the alert.
 *
 * @returns {JSX.Element} The rendered Alert component.
 */
import { faCircleXmark, faWarning } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Alert = ({ type = "warning", children }) => {
  let awesomeIcon = faWarning;
  if (type === "danger") {
    awesomeIcon = faCircleXmark;
  }

  return (
    <div className={`alert alert-${type}`} role="alert">
      <FontAwesomeIcon icon={awesomeIcon} /> {children}
    </div>
  );
};

export default Alert;
